var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 151177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 151171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34466"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.375,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#A8A8A8",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "video-camera 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.3152 13.0068H12.4514C11.1504 13.0068 10.0859 14.0713 10.0859 15.3723V23.3437C10.0859 24.6447 11.1504 25.7092 12.4514 25.7092H22.3152C23.6161 25.7092 24.6806 24.6447 24.6806 23.3437V15.3723C24.6806 14.0476 23.6161 13.0068 22.3152 13.0068Z",
    fill: "#ACACAC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.9359 14.3079C29.794 14.3315 29.6521 14.4025 29.5338 14.4735L25.8438 16.6023V22.0901L29.5575 24.219C30.2434 24.6211 31.095 24.3846 31.4971 23.6986C31.6154 23.4857 31.6863 23.2492 31.6863 22.989V15.6798C31.6863 14.8046 30.8584 14.095 29.9359 14.3079Z",
    fill: "#ACACAC"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.3e653cbec05c8df3fc39dd267fed4f96.svg";
export { ForwardRef as ReactComponent };